import * as React from 'react'
import clsx from 'clsx'
import styles from './index.module.scss'
import type { TooltipProps } from './Tooltip'
import { capitalize } from '../../utils'

export interface TooltipTooltipProps
  extends React.HTMLAttributes<HTMLDivElement>,
    Pick<TooltipProps, 'placement'> {
  classes?: {
    root: string
    arrow: string
    touch: string
    rtl: string
    ltr: string
    severityEerror: string
    severityInfo: string
    severitySuccess: string
    severityWarning: string
  }
  hasArrow: boolean
  hasTouch: boolean
  isRtl: boolean
  severity?: 'error' | 'info' | 'success' | 'warning'
}

export const TooltipTooltip = React.forwardRef<
  HTMLDivElement,
  TooltipTooltipProps
>((props, ref) => {
  const { classes, children, hasArrow, hasTouch, isRtl, severity, ...others } =
    props
  return (
    <div
      ref={ref}
      className={clsx(
        styles.tooltip,
        severity && [
          styles[`severity-${severity}`], // @ts-ignore
          classes?.[`severity${capitalize(severity)}`],
        ],
        classes?.root,
        hasArrow && [styles.arrow, classes?.arrow],
        hasTouch && [styles.touch, classes?.touch],
        isRtl ? [styles.rtl, classes?.rtl] : [styles.ltr, classes?.ltr]
      )}
      {...others}
    >
      {children}
    </div>
  )
})
TooltipTooltip.displayName = 'TooltipTooltip'
